enum RecipientsRecipientInfoFormFieldNames {
    type = "recipient_edit_recipient_info_type",
    country = "recipient_edit_recipient_info_country",
    recipient = "recipient_edit_recipient_info_recipient",
    contact = "recipient_edit_recipient_info_contact",
    email = "recipient_edit_recipient_info_email",
    referenceNumber = "recipient_edit_recipient_info_referenceNumber",
}

export default RecipientsRecipientInfoFormFieldNames;